<!-- MENU -->
<div *ngIf="mode === 'menu'">
	<button
		[matBadge]="(values ?? []).length"
		[matBadgeHidden]="(values ?? []).length === 0 || !badge"
		mat-button
		color="primary"
		[ngClass]="{
			'!text-white !bg-secondary dark:!bg-stroke !rounded-full !w-7 !h-7':
				outline && noLabel
		}"
		[matMenuTriggerFor]="autocompleteMenu">
		<span class="flex items-center">
			<!-- {{ 'SHARED.TAGS.LABEL' | translate }}
			<mat-icon>keyboard_arrow_down</mat-icon> -->
			<mat-icon
				*ngIf="!hashtag"
				ngStyle="{'color':noLabel ? '#080074' : 'grey' }"
				style="font-size: 1.5em; font-weight: bold; margin: -7px">
				turned_in
			</mat-icon>

			<span *ngIf="hashtag" class="text-lg font-light">#</span>
			<span
				ngStyle="{'color':noLabel ? '#080074' : 'grey' }"
				style="font-size: 1.1em"
				*ngIf="!noLabel"
				class="hidden lg-:flex">
				&nbsp; {{ 'SHARED.TAGS.LABEL' | translate }}</span
			>
		</span>
	</button>
	<mat-menu
		class="auto-complete-menu"
		#autocompleteMenu="matMenu"
		yPosition="below"
		xPosition="after">
		<div class="input autoComplete">
			<green-input-auto-complete
				[listValues]="listValues"
				[values]="values ?? []"
				[mode]="mode"
				[type]="type"
				(onChangedValues)="valuesChanged($event)" />
		</div>
	</mat-menu>
</div>

<!-- INPUT -->
<green-input-auto-complete
	*ngIf="mode === 'input'"
	class="input-mode"
	[values]="values ?? []"
	[mode]="mode"
	[listValues]="listValues"
	[type]="type" />

<!-- LIST -->
<div *ngIf="mode === 'list'">
	<div
		*ngIf="!editView"
		class="read-only-view flex items-center justify-center gap-3">
		<mat-chip-listbox aria-label="Dog selection" *ngIf="values">
			<mat-chip *ngFor="let value of values.slice(0, chipLimit)">
				<green-truncated-text class="text-xs" [value]="value" [maxLength]="7" />
			</mat-chip>
			<mat-chip
				*ngIf="hiddenTags > 0"
				[matTooltip]="values.slice(chipLimit).join(' | ')"
				selected="false"
				color="primary">
				+ {{ hiddenTags }}
			</mat-chip>
		</mat-chip-listbox>
		<span class="tags-empty" *ngIf="!values || values.length < 1">
			{{ 'SHARED.TAGS.EMPTY' | translate }}
		</span>
		<a
			*ngIf="type !== 'readonly'"
			mat-icon-button
			color="primary"
			(click)="toggleView()">
			<mat-icon inline>edit</mat-icon>
		</a>
	</div>
	<green-input-auto-complete
		*ngIf="editView"
		class="edit-view"
		[values]="values ?? []"
		[mode]="mode"
		[type]="type"
		[listValues]="listValues"
		(onChangedValues)="valuesChanged($event)"
		(editView)="editView = false" />
</div>

<!-- MENU ITEM -->
<a
	[ngClass]="{'pointer-events-none': disabled, 'opacity-50': disabled}"
	*ngIf="mode === 'menuItem'"
	mat-menu-item
	[matMenuTriggerFor]="autocompleteMenu"
	[matBadge]="(values ?? []).length"
	[matBadgeHidden]="(values ?? []).length === 0 || !badge">
	<mat-icon [color]="disabled ? 'disabled' : 'primary'"
		>bookmark_border</mat-icon
	>
	{{ 'SHARED.TAGS.LABEL' | translate }}
</a>
<mat-menu
	[ngClass]="{'pointer-events-none': disabled, 'opacity-50': disabled}"
	class="expanded autoComplete"
	#autocompleteMenu="matMenu"
	yPosition="below"
	xPosition="after">
	<div class="input">
		<green-input-auto-complete
			[ngClass]="{'pointer-events-none': disabled, 'opacity-50': disabled}"
			[values]="values ?? []"
			[mode]="mode"
			[type]="type"
			[listValues]="listValues"
			(onChangedValues)="valuesChanged($event)" />
	</div>
</mat-menu>

<div *ngIf="mode === 'listMenu'">
    <div
        class="read-only-view flex items-center justify-center gap-3">
        <mat-chip-listbox
            *ngIf="values"
            aria-label="Tag selection"
            [matMenuTriggerFor]="autocompleteListMenu"
            class="cursor-pointer">
            <mat-chip *ngFor="let value of values.slice(0, chipLimit)">
                <green-truncated-text class="text-xs" [value]="value" [maxLength]="7" />
            </mat-chip>
            <mat-chip
                *ngIf="hiddenTags > 0"
                [matTooltip]="values.slice(chipLimit).join(' | ')"
                selected="false"
                color="primary">
                + {{ hiddenTags }}
            </mat-chip>
        </mat-chip-listbox>
        <span
            class="tags-empty cursor-pointer"
            *ngIf="(!values || values.length < 1)"
            [matMenuTriggerFor]="autocompleteListMenu">
            {{ 'SHARED.TAGS.EMPTY' | translate }}
        </span>
        <a
            *ngIf="type !== 'readonly'"
            mat-icon-button
            color="primary"
            [matMenuTriggerFor]="autocompleteListMenu">
            <mat-icon inline>edit</mat-icon>
        </a>
    </div>
    <mat-menu
        class="auto-complete-menu"
        #autocompleteListMenu="matMenu"
        yPosition="below"
        xPosition="after">
        <div class="input autoComplete" (click)="$event.stopPropagation()">
            <green-input-auto-complete
                [listValues]="listValues"
                [values]="values ?? []"
                [mode]="mode"
                [type]="type"
                (onChangedValues)="valuesChanged($event)" />
        </div>
    </mat-menu>
</div>